"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungPropertiesDetails = void 0;
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
/**
 * Leitung properties that are used by the individual applications detail requests.
 */
class LeitungPropertiesDetails {
}
exports.LeitungPropertiesDetails = LeitungPropertiesDetails;
_a = echain_shared_igus_fundamentals_1.AppName.TEST, _b = echain_shared_igus_fundamentals_1.AppName.EIQ, _c = echain_shared_igus_fundamentals_1.AppName.EKE, _d = echain_shared_igus_fundamentals_1.AppName.EIC, _e = echain_shared_igus_fundamentals_1.AppName.ECF;
LeitungPropertiesDetails[_a] = [];
LeitungPropertiesDetails[_b] = [
    'Id',
    'EchainId',
    'ArtNr',
    'ArticleSpecs',
    'Aussendurchmesser',
    'ChainflexRef',
    'Chainflex',
    'Bezeichnung',
    'BiegeradiusMin',
    'Categories',
    'FesteLaenge',
    'GewichtKgProKm',
    'Id',
    'Kupferzahl',
    'Leitungsaufbau',
    'Leitungslaenge',
    'MainCategory',
    'Manufacturer',
    'ManufacturerPartNo',
    'RAL_Nummer',
    'Stecker1',
    'Stecker2',
    'SubCategory',
];
LeitungPropertiesDetails[_c] = [
    'Id',
    'EchainId',
    'Aderzahl',
    'AderzahlBerechnet',
    'ArtNr',
    'ArticleSpecs',
    'AuhiFreitragendA',
    'AuhiFreitragendV',
    'AuhiGleitend',
    'AuhiGleitendA',
    'AuhiGleitendV',
    'AuhiTemperaturMax',
    'AuhiTemperaturMin',
    'Aussendurchmesser',
    'ChainflexRef',
    'Chainflex',
    'BeschleunigungHaengendMax',
    'Bezeichnung',
    'BiegeradiusMin',
    'BusSystem',
    'Categories',
    'DESINA',
    'DNV_GL',
    'EAC',
    'FesteLaenge',
    'Flammwidrig',
    'Gesamtschirm',
    'GeschwindigkeitHaengendMax',
    'GewichtKgProKm',
    'HaengenderBetriebErlaubt',
    'Halogenfrei',
    'Kuehlmittelbestaendig',
    'Kupferzahl',
    'Leitungsaufbau',
    'Leitungslaenge',
    'MUDBestaendig',
    'MainCategory',
    'Mantelwerkstoff',
    'Manufacturer',
    'ManufacturerPartNo',
    'Oelbestaendigkeit',
    'Querschnitt',
    'RAL_Nummer',
    'Reinraum',
    'SubCategory',
    'Torsionswinkel',
    'TwistedPair',
    'UL_CSA',
    'UVBestaendigkeit',
    'VerfahrwegFreitragendMax',
    'VerfahrwegGleitendMax',
    'VerfahrwegHaengendMax',
];
LeitungPropertiesDetails[_d] = LeitungPropertiesDetails[echain_shared_igus_fundamentals_1.AppName.EKE];
LeitungPropertiesDetails[_e] = LeitungPropertiesDetails[echain_shared_igus_fundamentals_1.AppName.EKE];
//# sourceMappingURL=LeitungPropertiesDetails.js.map